/** @typedef {import('./definitions').GameConfig} GameConfig */

import { Device } from '@cardsjd/device';

import Games from './gameConfig';

export default class MarketPlace {
	appName = undefined;
	games = undefined;

	constructor(config) {
		const { appName, gamesUrl } = config;
		this.appName = appName;
		this.games = Games;

		if (gamesUrl) {
			this.fetchUpdatedList(gamesUrl);
		}
	}

	/**
	 * @param {string} newGamesUrl
	 * @returns {Promise<void>}
	 */
	async fetchUpdatedList(newGamesUrl) {
		try {
			const response = await fetch(newGamesUrl);
			const games = await response.json();

			if (games?.length > 0) {
				this.games = games;
			}
		} catch (err) {
			console.log('Error fetching updated games list, squleching', err);
		}

	}

	/**
	 * @param {string} osOverride
	 * @returns {boolean}
	 */
	hasGames(osOverride) {
		return this.getGames(osOverride).length > 0;
	}

	/**
	 * @param {string} [osOverride]
	 * @returns {GameConfig[]}
	 */
	getGames(osOverride) {
		let os = osOverride || this.getPlatform();
		if (os === 'windowsPWA') { os = 'windows'; }
		const games = this.games.filter(game => {
			return game[os] && game.name !== this.appName;
		});
		return games;
	}

	/**
	 * @param {string} id
	 * @returns {Promise<boolean | void>}
	 */
	async switchGameAsync(id) {
		if (typeof globalThis.FBInstant === 'undefined') {
			return Promise.resolve(false);
		}

		return globalThis.FBInstant?.switchGameAsync?.(id);
	}

	/**
	 * @param {string} appName
	 * @param {string} [osOverride]
	 * @returns {void}
	 */
	show(appName, osOverride) {
		let os = osOverride || this.getPlatform();
		if (os === 'windowsPWA') { os = 'windows'; }
		const game = this.games.find((game) => {
			return game[os] && game.name === appName;
		});

		if (game) {

			if (os === 'FBInstant') {
				this.switchGameAsync(game.FBInstant).catch(function (e) {
					console.log('fBInstantGame.switchGameAsync: Error: ' + JSON.stringify(e)); // Handle game change failure
				});
			} else {
				window.open(game[os], '_system');
			}
		}
	}
	getPlatform() {
		const device = new Device();
		return device.getPlatform();
	}
}

/**
 * @typedef {Object} MarketPlaceConfig
 * @property {string} appName
 * @property {string} [gamesUrl] 
 */
